import { Link } from "react-router-dom";
import "./Home.css";
import { useEffect, useState } from "react";
import decoration from "../../assets/homepage decoration.png";

const testimonials = [
    "I have listened to the recordings and I must say that I am mightily impressed. The results are better than I thought possible.",
    "The quality of the CD is superb - much better than I imagined and it has been a real pleasure to deal with you.",
    "You have done an excellent job and I can recognise all of the voices. I’ll be dropping the discs over to my parents later this week and I know that they are going to really enjoy listening to them again after all these years.",
    "It was a brilliant transfer, just like if issued by a commercial company. I'd love to know what equipment you use, because the transfers are so professional.",
    "My husband came to England to work in a hospital 45 years ago, his mother died suddenly soon after he arrived here and he never thought he would hear her voice again. I never met her, but today I feel that we have met for the first time. The quality is so good, and the tape is so clear and gets better and better as it goes on.",
    "I don't know how you do it but the sound quality is amazing. The Pattersons sound even better than they did on vinyl. I have no hesitation in recommending your services.",
];

export const Home = () => {
    const [testimonialIndex, setTestimonialIndex] = useState(0);
    const [testimonialClass, setTestimonialClass] = useState("fade-in");

    useEffect(() => {
        const fadeInterval = setInterval(() => {
            setTestimonialClass("fade-out");
            setTimeout(() => {
                testimonialIndex === testimonials.length - 1
                    ? setTestimonialIndex(0)
                    : setTestimonialIndex(testimonialIndex + 1);
                setTestimonialClass("fade-in");
            }, 1500);
        }, 4000);

        return () => clearInterval(fadeInterval);
    }, [testimonialClass]);

    return (
        <>
            <div className="home-container">
                <div style={{ flex: 2 }}>
                    <h1>Release the soundtrack to your life!</h1>
                    <p>
                        Do you have boxes of LPs, cassettes, reel-to-reel tapes
                        or precious 78's mouldering away in boxes in the attic
                        or hidden away in the garage? Do you want to convert
                        them to CD or MP3?
                    </p>
                    <p>
                        Then let us help! We can transfer all of the above onto
                        CD or into MP3 format and let you relive your musical
                        past...
                    </p>
                </div>
                <div className="home-testimonials-container">
                    <div className={testimonialClass + " home-testimonials"}>
                        "{testimonials[testimonialIndex]}"
                    </div>
                    <Link to="/testimonials">View all testimonials</Link>
                </div>
            </div>
            <div style={{ margin: "0 3rem" }}>
                <br />
                <p>
                    If you're interested in having your music cut to vinyl,
                    please have a look at{" "}
                    <a href="https://cuttinggrooves.co.uk">Cutting Grooves</a>
                </p>
            </div>
            <img className="decoration" src={decoration} />
        </>
    );
};
